import { useEffect, useState } from 'react'

import { useFederatedComponent } from 'modules/app-registry/hooks/useFederatedComponent'
import { CustomEvents } from 'shared/constants/customEvents'

export const TrackTicketsModal = () => {
  const [isOpen, setIsOpen] = useState(false)

  const { module, isLoaded, isError, missingRemoteUrl } = useFederatedComponent(
    process.env.REACT_APP_TASKMANAGEMENT_APP_V2_DEV_PATH,
    'task_management',
    './TaskManagementAppComponents',
    'taskManagementAppV2'
  )

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return

      if (event.data?.type === CustomEvents.OPEN_TRACK_TICKETS_MODAL) {
        setIsOpen(true)
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  if (!isOpen) return null

  if (!isLoaded || isError || missingRemoteUrl || !module) {
    return null
  }

  // @ts-expect-error: dynamic import
  const { TrackTicketsModal: TrackTicketsModalComponent } = module

  if (!TrackTicketsModalComponent) {
    return null
  }

  return (
    <TrackTicketsModalComponent
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
    />
  )
}
